module.exports = __webpack_public_path__ + "static/media/clouds-phone.ddf672e4.png";